import React from 'react';
import TaskBoard from './TaskBoard/TaskBoard';

// The Operations Task Board is its own redesigned page (List / Board / Map /
// Calendar views + filters) that reuses the existing Task data and the existing
// create/edit modals. The standalone Task module at /manage-tasks is left
// untouched and fully functional.
const Taskboard = () => <TaskBoard />;

export default Taskboard;
